import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=8104e42c&scoped=true&"
import script from "./reason.vue?vue&type=script&lang=js&"
export * from "./reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8104e42c",
  null
  
)

export default component.exports